import { render } from "./UiSocket.vue?vue&type=template&id=2f01bc38&ts=true"
import script from "./UiSocket.vue?vue&type=script&lang=ts"
export * from "./UiSocket.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__